import type { ReactElement, SVGProps } from 'react';
import { useId } from 'react';

import type { IconSVGProps } from './types';

/**
 * FinanceIcon: ícono para "Información financiera".
 */
export const FinanceIcon = ({
  className,
  width = 16,
  height = 16,
  ...props
}: IconSVGProps): ReactElement<SVGProps<SVGSVGElement>> => {
  const clipId = useId();

  return (
    <svg
      viewBox="0 0 16 16"
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      aria-hidden
      focusable="false"
      {...props}
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M15.5549 7.11114H14.7355C14.491 6.55558 14.1355 6.06392 13.6966 5.6528L14.2216 3.55558H13.3327C12.516 3.55558 11.7938 3.93058 11.3049 4.50836C11.0938 4.4778 10.8855 4.44447 10.666 4.44447H7.11048C4.96048 4.44447 3.16882 5.97225 2.75493 8.00003H1.55493C1.14382 8.00003 0.818818 7.62503 0.902151 7.20003C0.963263 6.88336 1.26048 6.66669 1.58271 6.66669H1.61048C1.70215 6.66669 1.77715 6.59169 1.77715 6.50003V5.94447C1.77715 5.8528 1.70215 5.7778 1.61048 5.7778C0.818818 5.7778 0.113263 6.34447 0.0132627 7.1278C-0.10896 8.0778 0.629929 8.88892 1.55493 8.88892H2.66604C2.66604 10.3389 3.3716 11.6139 4.44382 12.425V14.6667C4.44382 14.9111 4.64382 15.1111 4.88826 15.1111H6.66604C6.91048 15.1111 7.11048 14.9111 7.11048 14.6667V13.3334H10.666V14.6667C10.666 14.9111 10.866 15.1111 11.1105 15.1111H12.8883C13.1327 15.1111 13.3327 14.9111 13.3327 14.6667V12.425C13.6605 12.1778 13.9522 11.8861 14.2022 11.5556H15.5549C15.7994 11.5556 15.9994 11.3556 15.9994 11.1111V7.55558C15.9994 7.31114 15.7994 7.11114 15.5549 7.11114ZM11.9994 8.88892C11.7549 8.88892 11.5549 8.68892 11.5549 8.44447C11.5549 8.20003 11.7549 8.00003 11.9994 8.00003C12.2438 8.00003 12.4438 8.20003 12.4438 8.44447C12.4438 8.68892 12.2438 8.88892 11.9994 8.88892ZM7.11048 3.55558H10.666C10.816 3.55558 10.9633 3.56669 11.1077 3.5778C11.1077 3.56947 11.1105 3.56392 11.1105 3.55558C11.1105 2.08336 9.91604 0.888916 8.44382 0.888916C6.9716 0.888916 5.77715 2.08336 5.77715 3.55558C5.77715 3.61392 5.79104 3.66947 5.79382 3.7278C6.21604 3.61947 6.65493 3.55558 7.11048 3.55558Z"
          fill="inherit"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
